import { Injectable } from '@angular/core'
import { CommonService } from '../../shared/services/common.service'

@Injectable({
  providedIn: 'root',
})
export class GuestTrackingService {
  constructor(public commonService: CommonService) {}

  fetchOrderInformation(custNo, orderNo, poNo) {
    let urlParamLastPart = ''
    if (custNo !== null && custNo !== undefined) {
      const customerNumberParam = 'customerNumber=' + custNo
      urlParamLastPart = customerNumberParam
    }
    if (orderNo !== null && orderNo !== undefined) {
      const orderNoParam = '&orderNumber=' + orderNo
      urlParamLastPart = urlParamLastPart + orderNoParam
    }
    if (poNo !== null && poNo !== undefined) {
      const poNoParam = '&searchByValue=' + poNo
      urlParamLastPart = urlParamLastPart + poNoParam
    }
    const urlParam = [
      'users',
      'anonymous',
      `customerOrderStatus?${urlParamLastPart}`,
    ]

    const url = this.commonService.constructUrl(urlParam)
    const apiParams = {}
    return this.commonService.postData(url, apiParams)

    // return of({
    //   ordersList: [
    //     {
    //       code: '0000032727',
    //       placed: '2020-10-05T18:30:00+0000',
    //       currency: 'EUR €',
    //       lastUpdatedDate: '06-Oct-2020',
    //       orderStatus: 'Received',
    //       purchaseOrderDate: '2020-10-05T18:30:00+0000',
    //       purchaseOrderNumber: '567890',
    //       soldTo: 'CMI THERMLINE SERVICES SAS',
    //       totalNetPrice: '77.91',
    //     },
    //   ],
    //   pagination: {
    //     currentPage: 0,
    //     pageSize: 50,
    //     sort: 'UpdateDsc',
    //     totalPages: 1,
    //     totalResults: 1,
    //   },
    // });
  }

  fetchQuoteInformation(custNo, quoteNumber) {
    //https://localhost:9002/occ/v2/vsstore/users
    //anonymous/rfqcart/0000124085/searchQuote?quoteNumber=0005200017
    const lastParam = 'searchQuote?quoteNumber=' + quoteNumber
    const urlParam = ['users', 'anonymous', 'rfqcart', custNo, lastParam]
    const url = this.commonService.constructUrl(urlParam)
    const apiParams = {
      // quoteNumber: quoteNumber,
    }

    return this.commonService.postData(url, apiParams)

    // return of({
    //   pagination: {
    //     currentPage: 0,
    //     pageSize: 50,
    //     totalPages: 0,
    //     totalResults: 0,
    //   },
    //   quoteListingList: [
    //     {
    //       createdDate: '2020-08-25',
    //       quoteId: '0005200017',
    //       quoteReference: 'Quotetoorder1-1/5',
    //       quoteStatusCode: 'EXP',
    //       quoteStatusLabel: 'Expired',
    //       quoteTotal: 'EUR €6467.7',
    //     },
    //   ],
    // });
  }
}
